/**
 * Plural simple en español para copy user-facing.
 * `plural(2, 'venta', 'ventas')` → 'ventas'. Evita el patrón "venta(s)".
 */
export function plural(n: number, one: string, many: string): string {
  return n === 1 ? one : many;
}
